import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Ar } from './ar/ar';
import { AuthPopup } from './auth-popup/auth-popup';
import { Cinema } from './cinema/cinema';
import { Collections } from './collections/collections';
import { EnquiryPopup } from './enquiry-popup/enquiry-popup';
import { Fabs } from './fabs/fabs';
import { Finder } from './finder/finder';
import { Footer } from './footer/footer';
import { Franchise } from './franchise/franchise';
import { Header } from './header/header';
import { Hero } from './hero/hero';
import { MobileApp } from './mobile-app/mobile-app';
import { Popups } from './popups';
import { Preloader } from './preloader/preloader';
import { Products } from './products/products';
import { Story } from './story/story';
import { Testimonials } from './testimonials/testimonials';
import { Videos } from './videos/videos';

@Component({
  selector: 'app-root',
  imports: [Preloader, Header, Hero, Collections, Cinema, Ar, Products, Videos, Testimonials, Story, MobileApp, Franchise, Footer, Fabs, EnquiryPopup, Finder, AuthPopup],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '(click)': 'onClick($event)' },
})
export class App {
  private readonly popups = inject(Popups);

  /**
   * Handles the page's own "#section" links. Left to the browser they are
   * resolved against <base href="/">, so whenever the address carries a query
   * string — a campaign link, the ?fbclid=… Facebook adds — "#story" counts
   * as a different page and the whole site reloads instead of scrolling.
   */
  protected onClick(event: MouseEvent): void {
    // leave new-tab clicks (ctrl, middle button…) and anything already handled alone
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = (event.target as Element).closest('a[href^="#"]');
    const id = link?.getAttribute('href')?.slice(1);
    // "#enquire" is not a place on the page: it opens the Enquire Now popup, wherever the link stands
    if (id === 'enquire') {
      event.preventDefault();
      this.popups.show('enquiry');
      return;
    }
    const section = id ? document.getElementById(id) : null;
    if (!section) return;

    event.preventDefault();
    history.pushState(null, '', `${location.pathname}${location.search}#${id}`);
    // (smooth, and clear of the header: both come from styles.scss)
    section.scrollIntoView();

    // a link followed with the keyboard: carry on tabbing from the section, as the browser would
    if (event.detail === 0) {
      if (!section.hasAttribute('tabindex')) section.setAttribute('tabindex', '-1');
      section.focus({ preventScroll: true });
    }
  }
}
